/* eslint-disable consistent-return */
import { service } from '../api/axios';

export const getAllPostService = (topicId) =>
  service
    .get(`/topics/${topicId}/posts`)
    .then((responseFromAPI) => responseFromAPI.data);

export const getAllEventPostService = (eventId) =>
  service
    .get(`/events/${eventId}/posts`)
    .then((responseFromAPI) => responseFromAPI.data);

export const createPostService = async ({
  files,
  body,
  owner,
  topicId,
  eventId,
}) => {
  if (!eventId && !topicId) {
    throw new Error('Need one of: topicId, eventId');
  }
  const data = new FormData();
  files.forEach((file) => {
    data.append('images', file);
  });
  data.append('body', JSON.stringify(body));
  if (topicId) {
    data.append('topicId', topicId);
  }

  if (eventId) {
    data.append('eventId', eventId);
  }

  const response = await service.post(`/topics/${topicId}/posts`, data);
  return response.data;
};

export const putPost = async (id, content, fileUrls, topic, event) => {
  if (!topic && !event) {
    throw new Error('Need one of: topicId, eventId');
  }

  const body = {
    id,
    body: content,
    fileUrls,
    topic,
    event,
  };

  const response = await service.put('posts', body);
  return response.data;
};

export const getPostByIdService = (postId) => {
  return service
    .get(`/posts/${postId}`)
    .then((responseFromAPI) => responseFromAPI.data);
};

export const submitCommentService = (
  owner,
  commentBody,
  postId,
  responseToCommentId
) =>
  service
    .post(`/posts/${postId}/comments`, {
      owner,
      commentBody,
      postId,
      responseToCommentId,
    })
    .then((responseFromAPI) => responseFromAPI.data);

export const deleteCommentService = (commentId, id) =>
  service
    .put(`/deleteComment`, {
      commentId,
      id,
    })
    .then((responseFromAPI) => responseFromAPI.data);

export const likePostService = (postId, userId) =>
  service
    .put(`/posts/${postId}/likepost`, userId)
    .then((responseFromAPI) => responseFromAPI.data);

export const unlikePostService = (postId, userId) =>
  service
    .put(`/posts/${postId}/unlikepost`, userId)
    .then((responseFromAPI) => responseFromAPI.data);

export const deletePostService = async (postId) => {
  try {
    const deletingPost = await service.put('/deletePost', { postId });
    return deletingPost;
  } catch (error) {
    console.error(error);
  }
};

export const updatePostService = (postId, newPost) =>
  service
    .put(`/posts/${postId}`, newPost)
    .then((responseFromAPI) => responseFromAPI.data);
